import {
  addDoc,
  collection,
  getDocs,
  orderBy,
  query,
  serverTimestamp,
  where,
} from 'firebase/firestore';
import { firebaseAuth, firebaseDb } from '../firebase';

export const refundService = {
  /**
   * Créer une demande de remboursement
   */
  createRefundRequest: async (orderId, reason, description, amount) => {
    try {
      if (!firebaseAuth?.currentUser) {
        return { success: false, error: 'Non authentifié' };
      }
      if (!firebaseDb) {
        return { success: false, error: 'Firestore non configuré' };
      }
      const uid = firebaseAuth.currentUser.uid;
      const ref = await addDoc(collection(firebaseDb, 'refundRequests'), {
        userUid: uid,
        orderId,
        reason,
        description,
        amount: Number(amount) || 0,
        status: 'pending',
        createdAt: serverTimestamp(),
        updatedAt: serverTimestamp(),
      });
      return {
        success: true,
        refund: { id: ref.id, _id: ref.id, orderId, reason, description, amount },
      };
    } catch (error) {
      console.error('Erreur lors de la création de la demande de remboursement:', error);
      return {
        success: false,
        error: error.message || 'Erreur lors de la création de la demande',
      };
    }
  },

  /**
   * Obtenir toutes les demandes de remboursement
   */
  getAllRefunds: async (filters = {}) => {
    try {
      if (!firebaseAuth?.currentUser) {
        return { success: false, error: 'Non authentifié', refunds: [] };
      }
      if (!firebaseDb) {
        return { success: false, error: 'Firestore non configuré', refunds: [] };
      }
      const uid = firebaseAuth.currentUser.uid;
      let q = query(
        collection(firebaseDb, 'refundRequests'),
        where('userUid', '==', uid),
        orderBy('createdAt', 'desc')
      );
      if (filters.status) {
        q = query(
          collection(firebaseDb, 'refundRequests'),
          where('userUid', '==', uid),
          where('status', '==', filters.status),
          orderBy('createdAt', 'desc')
        );
      }
      const snap = await getDocs(q);
      const refunds = snap.docs.map((d) => ({ id: d.id, _id: d.id, ...d.data() }));
      return {
        success: true,
        refunds,
        count: refunds.length,
        total: refunds.length,
        page: 1,
        totalPages: 1,
      };
    } catch (error) {
      console.error('Erreur lors de la récupération des remboursements:', error);
      return {
        success: false,
        error: error.message || 'Erreur lors de la récupération des remboursements',
        refunds: [],
      };
    }
  },

  /**
   * Obtenir une demande de remboursement spécifique
   */
  getRefund: async (refundId) => {
    return { success: false, error: 'Lecture détaillée: à implémenter (Firestore getDoc).' };
  },

  /**
   * Approuver une demande de remboursement
   */
  approveRefund: async (refundId) => {
    return { success: false, error: 'Action agent/admin à implémenter via Cloud Functions.' };
  },

  /**
   * Rejeter une demande de remboursement
   */
  rejectRefund: async (refundId, rejectionReason) => {
    return { success: false, error: 'Action agent/admin à implémenter via Cloud Functions.' };
  },

  /**
   * Traiter un remboursement approuvé
   */
  processRefund: async (refundId) => {
    return { success: false, error: 'Traitement remboursement à implémenter via Cloud Functions.' };
  },

  /**
   * Annuler une demande de remboursement
   */
  cancelRefund: async (refundId) => {
    return { success: false, error: 'Annulation: à implémenter (update status dans Firestore).' };
  },
};





